module.exports = __webpack_public_path__ + "c254c33aba0332fef03beda3d6715b67.fbx";